import { render } from "./ContentSection.vue?vue&type=template&id=7cb982f7&scoped=true"
const script = {}

import "./ContentSection.vue?vue&type=style&index=0&id=7cb982f7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7cb982f7"

export default script